module.exports = __webpack_public_path__ + "static/media/designPatent_30-1053857.39401f8c.png";